import type { SortableHeaderProps } from '@app/src/components/Table'
import { TableCellWidth } from '@app/src/components/Table'
import TableHeaderCell from '@app/src/components/Table/Cells/TableHeaderCell'
import { TableRow } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface ProviderResponseHeaderProps extends SortableHeaderProps {
  showTargetProductColumn?: boolean
}

const ProviderResponseHeader: React.FC<ProviderResponseHeaderProps> = ({
  toggleSorting,
  activeSorting,
  showTargetProductColumn,
}): JSX.Element => {
  const { formatMessage } = useIntl()

  return (
    <TableRow>
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.response.responseStatus' })}
        minWidth={TableCellWidth.EMPTY}
      />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.response.request' })}
        sorting={{ name: 'request.title', toggleSorting, activeSorting }}
        minWidth={TableCellWidth.EXTRA_LARGE}
      />
      {showTargetProductColumn && (
        <TableHeaderCell label={formatMessage({ id: 'schemas.mappingNode.product' })} minWidth={TableCellWidth.LARGE} />
      )}
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.response.periodDisplayName' })}
        minWidth={TableCellWidth.SMALL}
      />
      <TableHeaderCell label={formatMessage({ id: 'schemas.response.companyName' })} />
      <TableHeaderCell
        label={formatMessage({ id: 'schemas.response.responseDate' })}
        sorting={{ name: 'submittedAt', toggleSorting, activeSorting }}
      />
    </TableRow>
  )
}

export default ProviderResponseHeader
